import { Injectable } from '@angular/core';

import { CriminalRecordCheckDocument, UserCriminalRecordCheck } from '@models';
import { CrudService, HttpService } from '@services';

@Injectable({ providedIn: 'root' })
export class CriminalRecordCheckService extends CrudService<CriminalRecordCheckDocument> {
  constructor(http: HttpService) {
    super('criminal-record-check', http);
  }

  async getLatest(): Promise<CriminalRecordCheckDocument> {
    const response = await this.http.get<CriminalRecordCheckDocument>(
      `${this.url}/latest`
    );
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async createCriminalRecordCheckDocument(
    data: Partial<CriminalRecordCheckDocument>,
    file?: File
  ): Promise<CriminalRecordCheckDocument> {
    const response = await this.http.postWithFile<CriminalRecordCheckDocument>(
      `${this.url}/`,
      data,
      file
    );
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async uploadProcessedUserCriminalRecordCheckDocument(
    data: Partial<UserCriminalRecordCheck>,
    file?: File
  ): Promise<UserCriminalRecordCheck> {
    const response = await this.http.postWithFile<UserCriminalRecordCheck>(
      `${this.url}/user/upload`,
      data,
      file
    );
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async setUserCriminalRecordCheckStatus(
    userCriminalRecordCheck: UserCriminalRecordCheck,
    status: string
  ): Promise<UserCriminalRecordCheck> {
    const response = await this.http.post<UserCriminalRecordCheck>(
      `${this.url}/user/status`,
      {
        userCriminalRecordCheckId: userCriminalRecordCheck.id,
        status,
      }
    );
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  async updateCriminalRecordCheckDocument(
    data: Partial<CriminalRecordCheckDocument>,
    file?: File
  ): Promise<CriminalRecordCheckDocument> {
    const response = await this.http.putWithFile<CriminalRecordCheckDocument>(
      `${this.url}/` + data.id,
      data,
      file
    );
    if (!response.success) throw new Error(response.message);
    return response.data;
  }

  override create(
    data: Partial<CriminalRecordCheckDocument>
  ): Promise<CriminalRecordCheckDocument> {
    throw new Error('Method not available.');
  }

  override update(
    data: Partial<CriminalRecordCheckDocument>
  ): Promise<CriminalRecordCheckDocument> {
    throw new Error('Method not available.');
  }

  override get(): Promise<CriminalRecordCheckDocument[]> {
    throw new Error('Method not available.');
  }

  override getById(id: string): Promise<CriminalRecordCheckDocument> {
    throw new Error('Method not available.');
  }
}
